import React from 'react'

export default function ConditionallyRender({when,children}) {
  return (
      <>
   {when ? children : null}
   </>
  )
}
